import type { ApplicationConfig } from ".";
import { baseConfig } from "./base.config";

export const prodConfig: ApplicationConfig = {
  ...baseConfig,
  organization: {
    ...baseConfig.organization,
    demoId: "ebf64778-0112-4230-ae83-39a5335358e5", // Aperture Inc.
    testId: "2f0c72f5-fe9a-4a42-bd26-cc32daa5b30b", // Automated Company
  },
  documentation: {
    ...baseConfig.documentation,
    url: "https://docs.iris.arup.com/",
  },
};
